export default function* logout() {
  yield console.log(logout);
}
